module.exports = __webpack_public_path__ + "img/Cutaways_house_2.d2a40b87.jpg";